import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { RentalList } from '../../../core/models/rental.model';
import { StatusLabelPipe } from '../../../shared/pipes/status-label.pipe';
import { formatDateTime } from '../../../shared/utils/date.utils';

@Component({
  selector: 'app-rental-card',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatChipsModule, StatusLabelPipe],
  templateUrl: './rental-card.component.html',
  styleUrl: './rental-card.component.scss',
})
export class RentalCardComponent {
  @Input() rental!: RentalList;
  @Input() showCarInfo = true;
  @Input() showHandoverLabel: boolean = false;
  @Input() showTypeBadge = false;
  formatDateTime = formatDateTime;
}
